import React from 'react'
import {Nullable} from '../../../../app/TypeHelpers'
import {NatGetRoomNumberList} from '../../roomNumber/repository/NatGetRoomNumberList'
import {Messages} from '../../../../Messages'
import {SelectedUser} from './NatResidentSelectedUser'
import { TableContainer, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import styled from 'styled-components'
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import {convertToRoomNumberForResident} from '../../../common/util/Natutil'

const SCROLL_BOUNDARY: number = 5;

interface Props {
    selectedUserList: SelectedUser[]
    checkStatus: { [key: string]: boolean }
    roomNumberList: NatGetRoomNumberList
    onUpdateSelectedUsers: (selectedUserList: SelectedUser[], checkStatus: { [key: string]: boolean }) => void
    isSearchCompleted: boolean
}

interface States {
    selectedUserList: SelectedUser[]
    checkStatus: { [key: string]: boolean };
}

export default class NatResidentUserSelectReadComponent extends React.Component<Props, States> {
    constructor(props: Props) {
        super(props);

        this.state = {
            selectedUserList: this.props.selectedUserList,
            checkStatus: this.props.checkStatus,
        };

        this.handleClickUser = this.handleClickUser.bind(this)
    }

    // ユーザ選択
    handleClickUser(ridgeCd: string, ridgeName: string, roomNumber: string): void {
        const check: boolean = this.state.checkStatus[`${ridgeName}_${roomNumber}`] || false;

        const selectedUserList: SelectedUser[] = this.state.selectedUserList;
        let tmpSelectedUserList: SelectedUser[] = [];

        // チェックを外した場合
        if (check) {
            // 棟名と部屋番号が一致しているデータを削除
            selectedUserList.some((selectedUser, index) => {
                if (selectedUser.ridgeName === ridgeName && selectedUser.roomNumber === roomNumber) {
                    selectedUserList.splice(index, 1);
                    tmpSelectedUserList = selectedUserList;
                    return true;
                }
            });
        } else {
            // チェックを付けた場合
            const clickSelectedUserList: SelectedUser[] = [{
                ridgeCd: ridgeCd,
                ridgeName: ridgeName,
                roomNumber: roomNumber,
            }];
            tmpSelectedUserList = selectedUserList.concat(clickSelectedUserList);
        }
        const checkStatus: { [key: string]: boolean } = {};
        tmpSelectedUserList.forEach((selectedUser) => {
            checkStatus[`${selectedUser.ridgeName}_${selectedUser.roomNumber}`] = true
        });


        this.setState({
            selectedUserList: tmpSelectedUserList,
            checkStatus: checkStatus,
        }, () => {
            this.props.onUpdateSelectedUsers(tmpSelectedUserList, checkStatus);
        })
    }

    render(): Nullable<React.ReactElement> {
        if (!this.props.isSearchCompleted) {
            return null
        } else if (this.props.roomNumberList.details === null ||
            this.props.roomNumberList.details.roomNumberInfo.length === 0) {
            return (
                <>
                    {Messages.IOPCC0014.toString('')}
                </>
            )
        }

        return (
            <>
                <StyledTableContainer>
                    <StyledTable>
                        <StyledTableHead>
                            <StyledTableRow>
                                <StyledTableCheckCell padding="checkbox" align={'center'}/>
                                <StyledTableCell align={'left'}>
                                    棟名
                                </StyledTableCell>
                                <StyledTableCell align={'left'}>
                                    部屋番号
                                </StyledTableCell>
                            </StyledTableRow>
                        </StyledTableHead>
                        <StyledTableBody count={(this.props.roomNumberList.details) ?
                            this.props.roomNumberList.details.roomNumberInfo.length : 0}>
                            {this.props.roomNumberList.details &&
                            this.props.roomNumberList.details.roomNumberInfo.map((roomNumber, index) =>
                                <StyledTableRow key={index}
                                                hover
                                                onClick={() => this.handleClickUser(
                                                    roomNumber.ridgeCd,
                                                    roomNumber.ridgeName,
                                                    roomNumber.roomNumber,
                                                )}>
                                    <StyledTableCheckCell padding="checkbox" align={'center'}>
                                        <CheckContainer>
                                            <input
                                                type="checkbox"
                                                name={`${roomNumber.ridgeName}_${roomNumber.roomNumber}`}
                                                checked={(this.state.checkStatus[
                                                    `${roomNumber.ridgeName}_${roomNumber.roomNumber}`
                                                    ] !== undefined)}
                                                readOnly
                                            />
                                        </CheckContainer>
                                    </StyledTableCheckCell>
                                    <StyledTableCell align={'left'}>
                                        {roomNumber.ridgeName}
                                    </StyledTableCell>
                                    <StyledTableCell align={'left'}>
                                        {convertToRoomNumberForResident(roomNumber.roomNumber)}
                                    </StyledTableCell>
                                </StyledTableRow>)
                            }
                        </StyledTableBody>
                    </StyledTable>
                </StyledTableContainer>
            </>
        )
    }
}

interface ScrollProps {
    count: number;
}

const StyledTableContainer = styled(TableContainer)`
  &.MuiTableContainer-root {
    border: solid 1px ${Colors.SecondaryActive};
  }
`;

const StyledTable = styled(Table)`
  &.MuiTable-root {
    display: block;
  }
`;

const StyledTableHead = styled(TableHead)`
  &.MuiTableHead-root {
    display: block;
    background-color: ${Colors.Background};
    font-size: ${FontSize.Body};
  }
`;

const StyledTableRow = styled(TableRow)`
 &.MuiTableRow-root {
   display: flex;
   align-items: center;
   border-bottom: 1px solid rgba(224, 224, 224, 1);
 }
`;

const StyledTableBody = styled(TableBody)<ScrollProps>`
  &.MuiTableBody-root {
    display: block;
  }

  ${props => props.count >= SCROLL_BOUNDARY ? `
    overflow-y:scroll;
    height:385px;
  ` : ``}
`;

const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-root {
   display: block;
   font-size: ${FontSize.Body};
   color: ${Colors.AccentDark};
   box-sizing:border-box;
   border-bottom: none;
   width: 40%;
  }
`;

const StyledTableCheckCell = styled(StyledTableCell)`
  &.MuiTableCell-root {
   width: 20%;
  }
`;

const CheckContainer = styled.div`
 align-content: center;
 display: flex;
 align-items: center;
 justify-content: center;
 height: 100%;
 -ms-transform: scale(1.5, 1.5);
 -webkit-transform: scale(1.5, 1.5);
 transform: scale(1.5, 1.5);
`;
